<template>
  <RouterLink
    :to="getRouterPath(module.shortcutModuleKey)"
    active-class="active-module"
    class="module"
    :class="{ teaser : module.authority === 'teaser' }"
    @click.native="toggle"
  >
    <div class="icon">
      <SvgIcon
        width="0.6em"
        :data="require('@icons/streamline-icons/Outline version/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg')"
      />
    </div>
    <div class="name">
      {{ module.moduleName }}
    </div>
  </RouterLink>
</template>

<script>
import menuComponent from '@/components/layout/navigation/menu/mixins/menuComponent';
import routerUtils from '@/components/common/mixins/routerUtils';
import mitt from 'mitt';

export default {
  name: 'MenuModuleShortcut',
  mixins: [menuComponent, routerUtils],
  props: {
    module: {
      type: Object,
      default: () => {
      },
    },
    eventBus: {
      type: Object,
      default: () => mitt(),
    },
  },
  methods: {
    toggle() {
      if (this.module.authority !== 'teaser') {
        this.eventBus.emit('module-clicked',
          {
            except: !this.showSubModules
              ? this.module.key
              : '',
            subModules: 0,
          });

        this.$emit('add-extra-height', 0);

        this.hideMenu();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "style";

  .module {
    &.active-module {
      background-color: var(--menu-module-active-bg-hex);
      position: relative;
    }
  }

</style>
